import { useEffect, useState, type ReactNode } from "react";
import { useConfig } from "../state/config-context";

export function CopyButton({ value, label }: { value: string; label?: string }): ReactNode {
  const { t } = useConfig();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return;
    }
    const timer = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(timer);
  }, [copied]);

  const onCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <button type="button" className="btn btn--ghost" onClick={() => void onCopy()}>
      {copied ? t("common.copied") : (label ?? t("common.copy"))}
    </button>
  );
}
